<script setup lang="ts">
// On garde ta logique de récupération YAML
const { data: page } = await useAsyncData('global-nav-footer', () => queryCollection('content').first())
</script>

<template>
  <UFooter
    :ui="{
      container: 'border-t border-white/10 py-12 flex flex-col sm:flex-row items-center gap-8 sm:gap-4',
      left: 'order-1 sm:order-none flex-1 flex items-center justify-center sm:justify-start w-full',
      center: 'order-2 sm:order-none flex-1 flex items-center justify-center w-full',
      right: 'order-3 sm:order-none flex-1 flex items-center justify-center sm:justify-end w-full'
    }"
  >
    <template #left>
      <nav class="flex flex-row justify-center gap-x-4 sm:gap-x-6 text-[11px] sm:text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
        <NuxtLink
          v-for="link in page?.navigation"
          :key="link.id"
          :to="link.to"
          class="hover:text-primary transition-colors"
        >
          {{ link.label }}
        </NuxtLink>
      </nav>
    </template>

    <template #default>
      <NuxtLink to="/" class="block">
        <img src="/logo.webp" alt="Ohmelec - Électricité Générale et Sécurité" width="300" height="263" class="h-16 sm:h-20 w-auto" loading="lazy" />      </NuxtLink>
    </template>

    <template #right>
      <div class="text-xs text-gray-400 flex flex-col sm:flex-row gap-y-4 sm:gap-x-8 justify-center items-center sm:items-end w-full">
        <NuxtLink
          to="/mentions-legales"
          class="py-2 hover:text-white transition-colors duration-200 hover:underline underline-offset-4"
        >
          Mentions légales
        </NuxtLink>
        <NuxtLink
          to="/politique-de-confidentialite"
          class="py-2 hover:text-white transition-colors duration-200 hover:underline underline-offset-4"
        >
          Confidentialité
        </NuxtLink>
      </div>
    </template>
  </UFooter>
</template>
